import { AnyRoute, createRoute, lazyRouteComponent } from '@tanstack/react-router'

import { alertsReportSchema } from './schema'

export const alertsReportRoute = <T extends AnyRoute>(indexRoute: T) =>
  createRoute({
    getParentRoute: () => indexRoute,
    path: 'alerts',
    component: lazyRouteComponent(() => import('./AlertsReport')),
    validateSearch: (search: Record<string, unknown>) => alertsReportSchema.parse(search)
  })
